import { useMutation } from '@tanstack/react-query';
import { useAxios } from '../useAxios';
import { ChallengeMode, TournamentConfig } from '@/types';

export interface CreateChallengePayload {
  Id: string;
  // Quiz config for both modes - uses categoryIds and numberOfQuestions for random selection
  Quiz: { 
    categoryIds: string[]; 
    title?: string;
    numberOfQuestions?: number;
    // Legacy: questions array for OneTimeMatching with pre-generated questions
    questions?: any[];
  };
  UsersIds: string[];
  Mode?: ChallengeMode;
  Title?: string;
  TournamentConfig?: TournamentConfig;
}

export const useCreateChallenge = () => {
  const axios = useAxios();

  return useMutation({
    mutationFn: async (payload: CreateChallengePayload) => {
      const response = await axios.post('/api/Challenges/CreateChallenge', payload);
      return response.data;
    },
  });
}; 